__turbopack_context__.v({
  "container": "index-module__HK3E1G__container",
  "modalContent": "index-module__HK3E1G__modalContent",
  "table": "index-module__HK3E1G__table",
});
